import { RenderIf } from '../../../components/RenderIf'
import { useMySelector } from 'featureSliced/shared/hooks/useMySelector'
import { useTranslations } from '../../../featureSliced/shared/hooks/useTranslations'
import { Discount } from './Discount'
import { Price } from './Price'
import { filterSpecialsForDisplay } from './filterSpecials'

import {
  IDiscount,
  IIndivPrice,
  IOfferPrice,
} from 'featureSliced/shared/store/reducers/SpecialsReducer/types'
import { CategoryItemText, Slider, SliderContainer } from './styled'
import { useOpenProduct } from 'featureSliced/shared/hooks/openModals/useOpenProductModal'
import { IProduct } from 'featureSliced/shared/store/reducers/CategoriesReducer/types'

// TODO: highlight special if it's added to bucket
export const Specials = () => {
  const t = useTranslations()
  const openProductModal = useOpenProduct()
  const handleProductClick = (
    product: IProduct,
    templateId: 'individualPrice' | 'discount' | 'offerPrice'
  ) => {
    openProductModal(product, templateId)
  }

  const categories = useMySelector((state) => state.categories.items)
  const specials = useMySelector((state) => state.specials)

  const { discounts, individualPrices, offerPrices, hasVisibleSpecials } =
    filterSpecialsForDisplay({ categories, ...specials })

  return (
    <RenderIf condition={hasVisibleSpecials}>
      <CategoryItemText className="special_category">
        {t('common.promotions')}
      </CategoryItemText>
      <SliderContainer>
        <Slider>
          {offerPrices.map((offer: IOfferPrice) => (
            <Price
              key={`offer_${offer.productId}`}
              individualPrice={offer}
              handleProductClick={(product: IProduct) =>
                handleProductClick(product, 'offerPrice')
              }
            />
          ))}
          {discounts.map((discount: IDiscount) => (
            <Discount
              key={discount.productId}
              discount={discount}
              handleProductClick={(product: IProduct) =>
                handleProductClick(product, 'discount')
              }
            />
          ))}
          {individualPrices.map((price: IIndivPrice) => (
            <Price
              key={price.productId}
              individualPrice={price}
              handleProductClick={(product: IProduct) =>
                handleProductClick(product, 'individualPrice')
              }
            />
          ))}
        </Slider>
      </SliderContainer>
    </RenderIf>
  )
}
